import React from "react";
import { Plus, Trash2 } from "lucide-react";
import AiPromptGenerator from "@/components/resume-builder/AiPromptGenerator";

const FIELD_CLASS = "bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-slate-400 focus:outline-none focus:ring-1 focus:ring-indigo-400";
const EMPTY_ENTRY = { label: "", url: "" };

export default function WebsitesSection({ draft, setDraft }) {
  const updateEntry = (idx, field, value) => setDraft({ ...draft, websites: draft.websites.map((e, i) => (i === idx ? { ...e, [field]: value } : e)) });
  const removeEntry = (idx) => setDraft({ ...draft, websites: draft.websites.filter((_, i) => i !== idx) });
  const addEntry = () => setDraft({ ...draft, websites: [...draft.websites, { ...EMPTY_ENTRY }] });

  return (
    <div className="glass-panel rounded-2xl p-5" data-testid="resume-section-websites">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold text-white">Website or Social Media</p>
        <button onClick={addEntry} data-testid="resume-add-website-button" className="flex items-center gap-1 text-xs font-semibold text-indigo-300 hover:text-indigo-200">
          <Plus className="w-3.5 h-3.5" /> Add Link
        </button>
      </div>
      <div className="space-y-2">
        {draft.websites.map((entry, idx) => (
          <div key={idx} className="flex items-center gap-2" data-testid={`resume-website-entry-${idx}`}>
            <input value={entry.label} onChange={(e) => updateEntry(idx, "label", e.target.value)} placeholder="Label (e.g. LinkedIn, Portfolio)" data-testid={`resume-website-label-${idx}`} className={FIELD_CLASS + " flex-1"} />
            <input value={entry.url} onChange={(e) => updateEntry(idx, "url", e.target.value)} placeholder="https://..." data-testid={`resume-website-url-${idx}`} className={FIELD_CLASS + " flex-1"} />
            <button onClick={() => removeEntry(idx)} data-testid={`resume-remove-website-${idx}`} className="text-slate-400 hover:text-red-400"><Trash2 className="w-3.5 h-3.5" /></button>
          </div>
        ))}
        {draft.websites.length === 0 && <p className="text-xs text-slate-400">No links added yet.</p>}
      </div>
      <div className="mt-3">
        <AiPromptGenerator section="websites" draft={draft} setDraft={setDraft} />
      </div>
    </div>
  );
}
